<template>
    <div class="contact-us">
        <div class="center-holder">
        <h1>Contact Us</h1>
        <p>Our Experts are here to help.</p>
        <p>Response timings 9am to 5pm IST, Monday to Saturday</p>
        <div style="height: 1rem"></div>
        <a :href="'tel:' + phoneNumber" class="contact" target="_blank">Phone {{ phoneNumber }}</a>
        <a :href="'mailto:' + email + '?subjet=Web%20Purchase'" class="contact" target="_blank">Email {{ email }}</a>
        <a :href="'https://wa.me/' + whatsApp" class="contact" target="_blank">WhatsApp {{ whatsApp }}</a>
        <div style="height: 1rem"></div>
        <div style="height: 1rem"></div>
        <h1>Office</h1>
        <p>Gopala Krishna Complex 45/3, Residency Road, Mahatma Gandhi Rd, Bengaluru, Karnataka 560025</p>
        <div style="height: 1rem"></div>
        <div style="height: 1rem"></div>
        <h1>Registered Address</h1>
        <p>260, 5th main, 4th block Jayanagar, Bengaluru 560011</p>

    </div>
    </div>
    <CFooter></CFooter>
</template>
<style scoped>
h1 {
    font-family: 'Zodiak-Regular', serif;
}
.contact-us{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
}
a {
    font-weight: bold;
    color: #0b54f1;
    text-decoration: none;
}
.contact {
    border: 2px solid #0b54f1;
    display: block;
    color: #0b54f1;
    width: 300px;
    margin: 0 auto;
    margin-top: 0.5rem;
    padding: 1rem;
}
</style>
<script>
import CFooter from '../components/CFooter.vue';

export default {
    components: {
        CFooter
    },
    computed: {
        phoneNumber: {
            get() {
                return "+91 8971830061";
            }
        },
        email: {
            get() {
                return this.$store.state.email
            }
        },
        whatsApp: {
            get() {
                return this.$store.state.whatsApp
            }
        }
    },
}
</script>